import Commodity from "domain/commodity";
import { OrderType } from "domain/orderType";

export function getCommodityPriceIncrement(commodity: Nullish<Commodity>, orderType: Nullish<OrderType>) {
    return orderType === OrderType.Tas ? commodity?.orderPriceIncrement : commodity?.bidPriceIncrement;
}

export function getAllowedPriceRange(isTasOrderType: boolean, isSpread: boolean, commodity: Nullish<Commodity>) {
    if (!isTasOrderType) {
        return {
            min: isSpread ? null : 0,
            max: null
        };
    }

    const priceIncrement = commodity?.orderPriceIncrement ?? 0;

    return {
        min: priceIncrement * -4,
        max: priceIncrement * 4
    };
}